import { css } from 'styled-components'
import { breakpoints } from '../../components/Theme/breakpoints'

export const media = Object.keys(breakpoints).reduce((acc, label) => {
  acc[label] = (styles) => css`
    @media (min-width: ${breakpoints[label]}) {
      ${styles}
    }
  `
  return acc;
}, {})
